import React from 'react';
import { Input, Button, Space } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { generateSlug } from '@/utils/slug';

interface SlugInputProps {
    value?: string;
    onChange?: (value: string) => void;
    brandName?: string;
    disabled?: boolean;
    placeholder?: string;
}

const SlugInput: React.FC<SlugInputProps> = ({
    value,
    onChange,
    brandName = '',
    disabled = false,
    placeholder = 'Sẽ tự động tạo từ tên thương hiệu'
}) => {
    const handleRegenerate = () => {
        if (brandName) {
            const generatedSlug = generateSlug(brandName);
            if (generatedSlug) {
                onChange?.(generatedSlug);
            }
        }
    };

    return (
        <Space.Compact style={{ width: '100%' }}>
            <Input
                value={value}
                onChange={(e) => onChange?.(e.target.value)}
                placeholder={placeholder}
                disabled={disabled}
                style={{ flex: 1 }}
            />
            <Button
                icon={<ReloadOutlined />}
                onClick={handleRegenerate}
                disabled={disabled || !brandName}
                title="Tạo lại slug từ tên thương hiệu"
            />
        </Space.Compact>
    );
};

export default SlugInput;
